import styled from "styled-components";

export const WeeksContainer = styled.div`
  margin: ${({ margin }) => (margin ? margin : "0 auto 8px")};
  padding: 16px;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const WeekTitle = styled.p`
  margin-bottom: 20px;
  font-size: 14px;
  color: #000;
`;
export const WeeksAligner = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
export const WeekContainer = styled.button`
  width: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  outline: none;
  border: none;
  border-right: ${({ borderRight }) => borderRight && "1px solid #C8C8C8"};
  cursor: pointer;
  pointer-events: ${({ pointerEvents }) => pointerEvents && pointerEvents};
`;
export const WeekNumber = styled.p`
  margin-bottom: 2px;
  font-size: 14px;
  font-weight: ${({ isSelected }) => isSelected && "bold"};
  color: ${({ color }) => color && color};
`;
export const WeekImg = styled.img`
  width: 14px;
  height: 14px;
`;
export const CurrentWeekText = styled.p`
  font-size: 12px;
  color: #f15a24;
`;
